import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-maximization",
  "use": "icon-maximization-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-maximization\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1024h819.2V204.8H0V1024zM81.066667 285.866667h657.066666v657.066666H81.066667V285.866667z\" p-id=\"2895\" /><path d=\"M123.733333 0v119.466667h81.066667v-38.4h738.133333v738.133333h-42.666666v81.066667H1024V0z\" p-id=\"2896\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol